import { useRef, useState } from "react";
import { eDate, sDate } from "../../apollo";
import refresh from "../../assets/icon/refresh.png";
import { ko } from "date-fns/esm/locale";
import searchdate from "../../assets/icon/searchdate.png";
import exit from "../../assets/icon/exit.png";
import { useCrPack } from "../../hooks/useCrPack";
import { useEffect } from "react";
import { useEditOrdersStatus } from "../../hooks/useEditOrdersStatus";
import React from "react";
import { Modal } from "@mui/material";
import { IDateSearchFormProps } from "./component-tab-order";
import { useForm } from "react-hook-form";
import {
  OrderStatus,
  CrPackInput,
  EditOrdersStatusInput,
  CrPackMutation,
  EditOrdersStatusMutation,
} from "../../generated/graphql";
import { ListOrder } from "../../routes/admin-list-order";

export interface ComponentTabDelivery {
  dataList?: any[];
  DataCallback?: () => void;
  refetch?(): void;
  setDateSearch?: (sDate?: Date, eDate?: Date) => void;
}

export const ComponentTabDelivery: React.FC<ComponentTabDelivery> = ({
  dataList = [],
  DataCallback,
  setDateSearch,
  refetch,
}) => {
  const [orderIds, setOrderIds] = useState<number[]>([]);
  const [open, setOpen] = React.useState(false);
  const [change, setChange] = React.useState<OrderStatus>(OrderStatus.Pending);
  const { register, getValues, handleSubmit } = useForm<IDateSearchFormProps>({
    mode: "all",
  });

  const refetchHandler = () => {
    window.location.href = "/order/delivery";
  };

  const onPackComplete = async (data: CrPackMutation) => {
    const {
      crPack: { ok, err },
    } = data;
    if (ok) {
      // alert("저장되었습니다");
      window.location.href = "/order/delivery";
    } else {
      alert(err);
    }
  };

  const orderIdsHandler = () => {
    var _array = [];
    var checklist: ListOrder[] = [...dataList];
    for (var i = 0; i < checklist.length; i++) {
      _array.push(checklist[i].id);
    }
    setOrderIds(_array);
  };

  const [crPack, { loading: packLoading }] = useCrPack(onPackComplete);
  const testHandler = () => {
    if (orderIds.length !== 0) {
      if (!packLoading) {
        if (window.confirm("체크된 상품들을 패키징 하겠습니까?")) {
          const crPackInput: CrPackInput = {
            orderIds: orderIds,
          };
          crPack({ variables: { input: crPackInput } });
        }
      }
    } else if (orderIds.length === 0) {
      alert("선택된 주문이 없습니다.");
    }
  };
  const onSubmit = () => {
    const { sDate, eDate } = getValues();
    if (setDateSearch) {
      setDateSearch(sDate, eDate);
    }
  };

  useEffect(() => {
    orderIdsHandler();
  }, [dataList]);

  // --- 상태 변경 한번에 ---
  const onEditCompleted = async (data: EditOrdersStatusMutation) => {
    const {
      editOrdersStatus: { ok, err },
    } = data;
    if (ok && refetch) {
      await refetch();
    } else {
      alert(err);
    }
  };
  const [editOrdersStatus, { loading }] = useEditOrdersStatus(onEditCompleted);
  const editOrdersStatusHandler = (status: OrderStatus) => {
    var orderIds: number[] = [];
    for (const data of dataList) {
      if (data.id) {
        orderIds.push(Number(data.id));
      }
    }
    if (!loading) {
      const editOrdersStatusInput: EditOrdersStatusInput = {
        orderIds,
        status,
      };
      editOrdersStatus({ variables: { input: editOrdersStatusInput } });
    }
  };

  return (
    <div className="flex flex-wrap justify-between">
      <div className="flex flex-wrap">
        <button
          className="py-3 px-4 relative"
          onClick={() => {
            refetchHandler();
          }}
        >
          <img src={refresh} alt="새로고침" className="w-[30px] h-[30px]" />
        </button>
        <button
          onClick={() => {
            setOpen(true);
          }}
          className="bg-[#555B94] w-[104px] h-[30px] py-[7px] text-xs text-center rounded-lg my-[13px] text-white"
        >
          상태변경
        </button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap gap-x-4 content-center">
          <h1 className="text-[#8B8C8C] text-sm flex flex-wrap content-center">
            기간
          </h1>
          <div className="flex flex-wrap content-center">
            <input
              {...register("sDate")}
              type="date"
              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            ></input>
          </div>
          <span className="text-white flex flex-wrap content-center">~</span>
          <div className="flex flex-wrap content-center">
            <input
              {...register("eDate")}
              type="date"
              className="border w-full  border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            ></input>
          </div>

          <button className="py-3">
            <img src={searchdate} alt="찾기" className="w-[32px] h-[30px]" />
          </button>
        </div>
      </form>
      <div className="flex flex-wrap justify-end pr-8">
        <div className="flex flex-wrap gap-x-3">
          <button
            className="bg-transparent bg-[#8b8c8c] w-[104px] h-[30px] py-[7px] text-xs font-bold text-center rounded-lg my-[13px] text-white"
            onClick={() => testHandler()}
          >
            PACK
          </button>
        </div>
      </div>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="max-w-[360px] w-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2   bg-[#F9F8F9] rounded-lg">
          <div className="text-center py-2 h-10 text-white font-bold bg-[#3D3E49] rounded-t-lg  ">
            <div className="flex flex-wrap justify-between">
              <p className="w-[240px] ml-[40px] font-bold text-base">
                배송 상태변경
              </p>
              <img
                src={exit}
                alt="닫기"
                className="w-6 mr-2 cursor-pointer"
                onClick={() => setOpen(false)}
              ></img>
            </div>
          </div>
          <div className="flex flex-wrap content-center">
            <div className="px-10 py-10">
              <div className="grid grid-rows-6 gap-y-4">
                <p className="font-bold">주문내역</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="bound"
                    value={OrderStatus.Bound}
                    checked={change === OrderStatus.Bound}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Bound);
                      }
                    }}
                  ></input>
                  <span className="ml-4">출고대기</span>
                </div>
                <p className="font-bold">배송준비</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="pending"
                    value={OrderStatus.Pending}
                    checked={change === OrderStatus.Pending}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Pending);
                      }
                    }}
                  ></input>
                  <span className="ml-4">배송 준비</span>
                </div>

                <p className="font-bold">배송중</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Drone"
                    value="Drone"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Drone);
                      }
                    }}
                  ></input>
                  <span className="ml-4">드론 비행</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Port"
                    value="HandOut"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Port);
                      }
                    }}
                  ></input>
                  <span className="ml-4">최종 배송준비</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Stored"
                    value="Stored"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Stored);
                      }
                    }}
                  ></input>
                  <span className="ml-4">픽업포트</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="PendingDelivered"
                    value="PendingDeliverd"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.PendingDelivered);
                      }
                    }}
                  ></input>
                  <span className="ml-4">최종 배송</span>
                </div>
                <p className="font-bold">배송완료</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="check"
                    value="Delivered"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Delivered);
                      }
                    }}
                  ></input>
                  <span className="ml-4">배송 완료</span>
                </div>
                <p className="font-bold">환불/교환</p>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="Refunded"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Refunded);
                      }
                    }}
                  ></input>
                  <span className="ml-4">환불</span>
                </div>
                <div>
                  <input
                    type="radio"
                    name="order"
                    id="end"
                    value="Exchange"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setChange(OrderStatus.Exchange);
                      }
                    }}
                  ></input>
                  <span className="ml-4">교환</span>
                </div>
              </div>
            </div>
          </div>
          <button
            className="w-full h-14 bg-[#F0F0F4] rounded-b-lg"
            onClick={() => {
              editOrdersStatusHandler(change);
              setOpen(false);
            }}
          >
            확인
          </button>
        </div>
      </Modal>
    </div>
  );
};
